/* eslint-disable class-methods-use-this */
class ConfigService {
  get(key: string): string {
    return window.RUNTIME_CONFIG?.[key] || process.env[key] || '';
  }
}

export const configService = new ConfigService();
